// src/components/Security/Security.js
import React from "react";
import "./Security.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
  

const VideoSection = ({ videoSrc }) => (
  <div className="security-topvideo-container">
    <video
      className="security-topvideo"
      autoPlay
      loop
      muted
      playsInline
    >
      <source src={videoSrc} type="video/mp4" />
      Your browser does not support the video tag.
    </video>
  </div>
);

const DetailSection = ({ title, icon, description, list }) => (
  <div className="security-detail-section">
    <h2>
      <i className={`fas ${icon}`}></i> {title}
    </h2>
    <p>{description}</p>
    <ul>
      {list.map((item, index) => (
        <li key={index}>
          <i className={`fas ${item.icon}`}></i> {item.text}
        </li>
      ))}
    </ul>
  </div>
);

const Security = () => {
  const sections = [
    {
      title: "Backend and Frontend Security",
      icon: "fa-shield-alt",
      description:
        "Security is a top priority in both backend and frontend development. We implement robust security measures to ensure your website and mobile apps are safe from potential threats.",
      list: [
        { icon: "fa-user-lock", text: "Strong authentication systems (JWT, OAuth, 2FA)." },
        { icon: "fa-lock", text: "Data encryption and secure API communication." },
        { icon: "fa-search-plus", text: "Security audits and vulnerability assessments." },
        { icon: "fa-sync-alt", text: "Regular software updates to patch security holes." },
      ],
    },
    {
      title: "Service and Website Development",
      icon: "fa-cogs",
      description:
        "We specialize in developing custom web and mobile applications tailored to meet your unique business needs. Our services include:",
      list: [
        { icon: "fa-laptop-code", text: "Custom website development with a focus on performance, scalability, and security." },
        { icon: "fa-mobile-alt", text: "Mobile app development (iOS and Android) with a seamless user experience." },
        { icon: "fa-server", text: "Full-stack development for robust, data-driven applications." },
        { icon: "fa-plug", text: "Integration with third-party services, APIs, and payment gateways." },
      ],
    },
    {
      title: "Customization and Security Fixes",
      icon: "fa-wrench",
      description:
        "We offer customized solutions to fix security vulnerabilities and tailor your application to your specific needs.",
      list: [
        { icon: "fa-search", text: "Identifying and resolving potential security issues." },
        { icon: "fa-code", text: "Secure coding practices for backend and frontend." },
        { icon: "fa-tools", text: "Ongoing maintenance and updates to keep your service secure." },
        { icon: "fa-cogs", text: "Customizing features to suit your business requirements." },
      ],
    },
    {
      title: "Cloud Solutions and Scalability",
      icon: "fa-cloud-upload-alt",
      description:
        "Our cloud solutions ensure that your applications can scale seamlessly and perform optimally. Our services include:",
      list: [
        { icon: "fa-cloud", text: "Cloud architecture design for cost-effective hosting solutions." },
        { icon: "fa-server", text: "Serverless backend solutions using AWS Lambda or Google Cloud Functions." },
        { icon: "fa-chart-line", text: "Scalability solutions for increasing traffic and data loads." },
      ],
    },
    {
      title: "Collaboration and Support",
      icon: "fa-users",
      description:
        "Our team works closely with your business to ensure the development process aligns with your goals.",
      list: [
        { icon: "fa-comments", text: "Regular communication and progress updates." },
        { icon: "fa-handshake", text: "Seamless collaboration to understand your needs." },
        { icon: "fa-headset", text: "Ongoing support and troubleshooting after deployment." },
      ],
    },
  ];

  return (
    <div className="security-project-details-container">
      <header className="security-project-details-header"></header>
      <VideoSection videoSrc="/videos/25.mp4" />
      <section className="security-project-details-content">
        {sections.map((section, index) => (
          <DetailSection
            key={index}
            title={section.title}
            icon={section.icon}
            description={section.description}
            list={section.list}
          />
        ))}
      </section>
    </div>
  );
};

export default Security;
